
import { defineComponent } from 'vue';

import useConfig from '@/composables/useConfig';

export default defineComponent({

	name: "Home",

	setup() { 
		
		const config = useConfig()	

		// files.test.value = "gekkeding";
		// console.log("AA", files.test.value)

		return config

	}

})
